import { render, staticRenderFns } from "./UpdateAliasCVU.vue?vue&type=template&id=9d772474&"
import script from "./UpdateAliasCVU.vue?vue&type=script&lang=js&"
export * from "./UpdateAliasCVU.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports